module.exports = __webpack_public_path__ + "static/img/ipad_notice.a45c672.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/ipad_notice.jpg
// module id = /GEi
// module chunks = 42